module.exports = __webpack_public_path__ + "assets/img/travel-day2.42427e7c.png";